import config from '../Config'
import { api } from '../Services/api'
import { track } from './analytics'

export function storyUrl(storyId) {
  return `${config.SITE_URL}/prica/${storyId}`
}

/* Outbound click to the portal's article (the link itself opens it in a new
   tab): counts a read for "Najčitanije" and logs the event. */
export function articleOpened({ articleId, source, from }) {
  api.articleOpened(articleId)
  track('article_outbound_click', { source: source?.slug, from })
}
